import { useT } from "@/lib/i18n";
import { useLanderUsage } from "@/lib/services/lander-service";
import { CatalogPicker, type CatalogOption } from "./catalog-picker";

export interface LanderPickerProps {
  value?: string;
  onChange: (id: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

/** A lander from the whole library, with where it is already used. */
export function LanderPicker(props: LanderPickerProps) {
  return <CatalogPicker kind="lander" {...props} renderSub={(o) => <LanderUsageHint option={o} />} />;
}

function LanderUsageHint({ option }: { option: CatalogOption }) {
  const t = useT();
  const { data } = useLanderUsage(option.id);
  const line = [option.sub, data && data.flowCount > 0 ? t("picker.usedIn", { flows: data.flowCount, campaigns: data.campaignCount }) : ""].filter(Boolean).join(" · ");
  return line ? <span className="block truncate text-xs text-muted-foreground">{line}</span> : null;
}
